const events = [{
    name: 'Corporate Events',
    path: 'corporate',
    icon: 'confetti.png',
    description: '',
    image: 'corporate.jpg',
    theme: '#D99873'
},{
    name: 'Birthday Parties',
    path: 'birthday',
    icon: 'party-balloons.png',
    description: '',
    image: 'birthday-1.jpg',
    theme: "#02735E"
},{
    name: 'Other Parties',
    path: 'other',
    icon: 'party-hat.png',
    description: '',
    image: 'others.jpg',
    theme: "#D97762"
}];

export default events